import React, { useContext } from 'react';
import cn from 'classnames';

import { type ArenaOffersDto } from '@/common/types/shop/marketBoxes';
import { ModalContext } from '@/components/Modals/Modal/config';
import { BuyForTgStarButton } from '@/components/ui/BuyForTgStarButton/BuyForTgStarButton';
import RadialCircleGradient from '@/components/ui/Gradient/RadialCircleGradient';
import { Picture } from '@/components/ui/Picture/Picture';
import ArenaOfferTimer from '@/components/ui/Timer/ArenaOfferTimer';

import { arenaOffersInfo } from '../../config';
import SwitchCardsButton from '../SwitchCardsButton';

import shinePng from '/img/shop/arenaOffers/light.png';
import shineWebp from '/img/shop/arenaOffers/light.webp';
import dropIcon from '/img/shop/arenaOffers/profitDropIcon.svg';

interface ProfitDropDefaultTabProps {
  activeCard: ArenaOffersDto;
}

const ProfitDropDefaultTab: React.FC<ProfitDropDefaultTabProps> = ({
  activeCard,
}) => {
  const { name, cost, discountTimeLeftInSeconds } = activeCard;
  const isDiscount: boolean = cost.has_discount;
  const prices = isDiscount ? cost.discounted : cost.base;
  const info = arenaOffersInfo[name];
  const { openModal } = useContext(ModalContext);

  const onBuyOffer = (): void => {
    openModal({
      renderKind: 'buyArenaOffer',
      props: {
        arenaOffer: activeCard,
      },
    });
  };

  return (
    <>
      <div
        className={cn(
          'absolute top-0 left-0 w-full h-full aspect-ratio-1/1 z-[-1] overflow-hidden',
        )}
      >
        <div className="absolute block !w-[200px] aspect-ratio-1/1 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
          <Picture
            img={info.img.png}
            webp={info.img.webp}
            className="w-full h-full"
            alt="banner"
          />
          <img
            src={dropIcon}
            alt="profit drop icon"
            className="absolute block !w-[90px] aspect-ratio-1/1 top-0 right-0"
          />
        </div>
        <Picture
          img={shinePng}
          webp={shineWebp}
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[-2] !w-full !h-full"
          alt="shine"
        />
        <RadialCircleGradient
          type="purple"
          className="top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 aspect-ratio-1/1 !w-[150%]"
        />
      </div>

      <div className="flex gap-2 h-[32px]">
        <SwitchCardsButton />
        <div className="relative h-full flex-1">
          {isDiscount && (
            <ArenaOfferTimer value={discountTimeLeftInSeconds} variant="top" />
          )}
          <BuyForTgStarButton
            className="h-full !w-full"
            price={isDiscount ? cost.base.usd : undefined}
            discountPercentage={
              isDiscount ? cost.displayDiscountPct : undefined
            }
            discountPrice={prices.usd}
            wrapperClassName="w-full h-full"
            onClick={onBuyOffer}
          />
        </div>
      </div>
    </>
  );
};

export default ProfitDropDefaultTab;
